<template>
    <div class="textbook-content" :native="false">
        <el-scrollbar class="textbook-list">
            <div class="textbook">
                <div
                    class="textbook-item"
                    v-for="item in textbookList"
                    v-if="textbookList.length > 0"
                    @click="viewDetail(item)"
                >
                    <div class="textbook-cover">
                        <img
                            src="../../../assets/img/image/textbook.png"
                            alt=""
                            class="textbook-icon"
                        />
                    </div>
                    <span class="textbook-name" :title="item.resource_title">{{
                        item.resource_title
                    }}</span>
                </div>
                <div v-if="textbookList.length === 0" class="no-data">
                    <span>暂无数据</span>
                </div>
            </div>
        </el-scrollbar>
        <ResourceDialog
            :dialogVisible="dialogVisible"
            :src="src"
            @closeDialog="closeDialog"
        ></ResourceDialog>
    </div>
</template>

<script>
import ResourceDialog from '../../components/ResourceDialog'

export default {
    name: 'Textbook',
    components: {
        ResourceDialog
    },
    props: ['searchInput'],
    data() {
        return {
            textbookList: [],
            src: '',
            dialogVisible: false
        }
    },
    created() {
        this.getCourseInfo()
    },
    watch: {
        searchInput(d) {
            if (d !== '') {
                let arr = []
                for (let i = 0; i < this.textbookList.length; i++) {
                    if (this.textbookList[i].resource_title.indexOf(d) !== -1) {
                        arr.push(this.textbookList[i])
                    }
                }
                this.textbookList = arr
            } else {
                this.textbookList = []
                this.getCourseInfo()
            }
        }
    },
    methods: {
        //获取教材列表
        getCourseInfo() {
            let params = {
                id: this.$route.query.course_id
            }
            this.$shttp.axiosGetBy(
                this.$api.courseinfo,
                params,
                res => {
                    if (res.code === 200) {
                        // console.log('教材',res.data.reslist)
                        for (let i = 0; i < res.data.reslist.length; i++) {
                            if (res.data.reslist[i].resource_type_id === 2) {
                                this.textbookList.push(res.data.reslist[i])
                            }
                        }
                    }
                },
                error => {
                    console.log(error)
                }
            )
        },
        viewDetail(item) {
            this.src = item.file_preview_path
            this.dialogVisible = true
        },
        closeDialog() {
            this.src = ''
            this.dialogVisible = false
        }
    }
}
</script>

<style scoped lang="scss">
.textbook-content {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    .textbook-list {
        flex: 1;
        width: 100%;
        height: 1%;
        background-color: #fff;
        ::v-deep .el-scrollbar__wrap {
            overflow-x: hidden;
        }
        .textbook {
            padding: 0 20px;
            display: flex;
            flex-wrap: wrap;
            .textbook-item {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                margin: 30px 16px 0;
                cursor: pointer;
                border-radius: 10px;
                &:hover {
                    transform: scale(1.2);
                    transition: 1s;
                }
                .textbook-cover {
                    position: relative;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 107px;
                    height: 107px;
                }
                img.textbook-icon {
                    max-width: 100%;
                    max-height: 100%;
                    border-radius: 5px;
                }
                span.textbook-name {
                    color: #333;
                    font-size: 12px;
                    margin-top: 10px;
                    display: block;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    width: 107px;
                    text-align: center;
                }
            }
        }
    }
}
.no-data {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    margin-top: 50px;
}
</style>
